import { Prompt } from "@/types/app/prompt";
import { DescriptionDetails, DescriptionList, DescriptionTerm } from "../../DescriptionList";
import CodePreview from "../../Code/CodePreview";
import { PageSectionHeader } from "@components/library/PageSectionHeader";

export const JsonSchemaDetails = (props: Pick<Prompt, "response_format">) => {
  return (
    props.response_format &&
    props.response_format.type === "json_schema" && (
      <div className="mt-24">
        <PageSectionHeader title={"Response Format"} size="sm" />
        <div className={"flex flex-col gap-6"}>
          <DescriptionList>
            <DescriptionTerm className="flex gap-6">JSON Schema</DescriptionTerm>
            <DescriptionDetails>
              <CodePreview language="json" wrapLongLines className=" text-12-16">
                {JSON.stringify(props.response_format.json_schema, null, 2)}
              </CodePreview>
            </DescriptionDetails>
          </DescriptionList>
        </div>
      </div>
    )
  );
};
